import React, { memo } from "react";
import styles from "./active-request-card.module.scss";
import CircularProgress from "../../../../../common/components/circular-progress/CircularProgress";
import { ThunderBottomIcon, ArrowUpRightOrangeIcon } from "../../../../../assets/icons";

interface ActiveRequestCardProps {
	requestName?: string;
	percentage?: number;
	requestId?: string;
	onDetailsPress?: () => void;
}

const ActiveRequestCard: React.FC<ActiveRequestCardProps> = memo(({
	requestName,
	percentage,
	requestId,
	onDetailsPress,
}) => {
	const hasActiveRequest = Boolean(requestId);
	const resolvedPercentage = percentage ?? 0;

	return (
		<div
			className={`${styles.card} ${hasActiveRequest ? styles.cardClickable : ""}`}
			onClick={hasActiveRequest ? onDetailsPress : undefined}
			role={hasActiveRequest ? "button" : undefined}
			tabIndex={hasActiveRequest ? 0 : undefined}
			onKeyDown={hasActiveRequest ? (e) => e.key === "Enter" && onDetailsPress?.() : undefined}
		>
			<ThunderBottomIcon className={styles.thunder} aria-hidden />

			<div className={styles.header}>
				<div className={styles.headerRow}>
					<CircularProgress percentage={resolvedPercentage} size={64} />

					<div className={styles.divider} />

					<div className={styles.textColumn}>
						<span className={styles.label}>Active Request</span>
						{hasActiveRequest && requestName ? (
							<span className={styles.requestName}>{requestName}</span>
						) : (
							<span className={styles.requestNameEmpty}>No active requests</span>
						)}
					</div>
				</div>
			</div>

			{hasActiveRequest && (
				<div className={styles.footer}>
					<span className={styles.footerHint}>Tap to view and track progress</span>
					<div className={styles.detailsButton}>
						<ArrowUpRightOrangeIcon className={styles.detailsIcon} aria-hidden />
						<span className={styles.detailsLabel}>Details</span>
					</div>
				</div>
			)}
		</div>
	);
});

export default ActiveRequestCard;
